import { HookTextField, useHookForm } from "mui-react-hook-form-plus";
import { Box, DialogContent, FormLabel } from "@mui/material";
import React from "react";
import { FormStepProps } from "../SwiperStepperActions";
import FormStep from "../../modernTS/Forms/FormStep";

export type UpsellInitData = {
  name: string;
};

export function InitUpsellPage(formStepProps: FormStepProps) {
  const hookForm = useHookForm<UpsellInitData>({
    defaultValues: {
      name: "",
    },
  });
  const { registerState, handleSubmit, getValues } = hookForm;

  return (
    <FormStep form={hookForm} {...formStepProps}>
      <DialogContent>
        <Box sx={{ display: "grid", gap: 1 }}>
          <FormLabel>Name your upsell</FormLabel>
          <HookTextField
            textFieldProps={{
              variant: "filled",
              label: "Name",
              helperText: "This name is shown in the backoffice, not to customers",
            }}
            {...registerState("name")}
            rules={{
              required: true,
            }}
          />
        </Box>
      </DialogContent>
    </FormStep>
  );
}
